/* eslint-disable @typescript-eslint/no-explicit-any */
// constants
import { RUPEE } from '@/constants/icons/unicode';
export function isEmpty(value, ignoreWhitespace = true) {
    switch (typeof value) {
        case 'string':
            return ignoreWhitespace
                ? value.length === 0
                : value.trim().length === 0;
        case 'number':
        case 'boolean':
            return !value;
        case 'undefined':
            return true;
        case 'object':
            return !!(value === null || Object.keys(value).length === 0); // handling for null.
        case 'function':
        case 'symbol':
            return false;
        /* istanbul ignore next */
        default:
            return !value;
    }
}
// eslint-disable-next-line
export function debounce(func, wait) {
    let timeoutID;
    if (!Number.isInteger(wait)) {
        console.warn('Called debounce without a valid number');
        wait = 300;
    }
    return function (...args) {
        clearTimeout(timeoutID);
        const context = this; // eslint-disable-line
        timeoutID = window.setTimeout(function () {
            func.apply(context, args);
        }, wait);
    };
}
const FORMAT_REGEX = new RegExp('{-?[0-9]+}', 'g');
export function format(str, ...args) {
    return str.replace(FORMAT_REGEX, (item) => {
        const intVal = parseInt(item.substring(1, item.length - 1), 10);
        let replace;
        if (intVal >= 0) {
            replace = args[intVal];
        }
        else if (intVal === -1) {
            replace = '{';
        }
        else if (intVal === -2) {
            replace = '}';
        }
        else {
            replace = '';
        }
        return replace;
    });
}
export function trimString(inputString) {
    return inputString.trim();
}
export const formatNumberIntl = ({ value, defaultValue = 0, maximumFractionDigits = 0, }) => {
    if (!value)
        return defaultValue;
    try {
        const parsedValue = Number(value);
        return Intl.NumberFormat('en-IN', { maximumFractionDigits }).format(parsedValue);
    }
    catch (err) {
        return defaultValue;
    }
};
export const prefixWithRupee = (value) => {
    return `${String.fromCharCode(RUPEE)}${value}`;
};
export const getParsedMetricValue = (metric) => {
    if (!metric)
        return '-';
    return metric.toString();
};
export const validateEmail = (email) => {
    const regex = /^\S+@\S+\.\S+$/;
    return regex.test(email);
};
export const isValidOtpInput = (key) => {
    return isDeleteOrBackspace(key) || !isNaN(Number(key));
};
export const isDeleteOrBackspace = (key) => {
    return key === 'Backspace' || key === 'Delete';
};
const _toString = Object.prototype.toString;
export const isBoolean = (val) => {
    return _toString.call(val) === '[object Boolean]';
};
export const isString = (val) => {
    return _toString.call(val) === '[object String]';
};
export const isNumber = (val) => {
    return _toString.call(val) === '[object Number]';
};
export const isUndefined = (val) => {
    return _toString.call(val) === '[object Undefined]';
};
export const isNull = (val) => {
    return _toString.call(val) === '[object Null]';
};
export const isArray = (val) => {
    return _toString.call(val) === '[object Array]';
};
export const isObject = (val) => {
    return _toString.call(val) === '[object Object]';
};
export const isFunction = (val) => {
    return _toString.call(val) === '[object Function]';
};
